import { CampagneModel } from "@/app/entities";
import {
  DashboardHeader,
  SideImageCard,
  UiBadge,
  UiButton,
  UiSuspendButton,
} from "@/components";
import { useCampagne } from "@/composables/campagne";
import { ArrowLeft, Edit, Goal, Ban } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { RowInformation } from "@/components/atoms/list";
import { useToast } from "@/composables/toast";
import { formatAppDate, formatAppDateTime } from "@/utils/dates";

export default function DashboardCampagneDetail() {
  const { reference } = useParams<{ reference: string }>();
  const navigate = useNavigate();
  const {
    getCampagneByReference,
    suspendCampagne,
    loading,
    getCampagneStatusLabel,
    getCampagneStatusCode,
  } = useCampagne();
  const [campagne, setCampagne] = useState<CampagneModel | undefined>(
    undefined
  );

  useEffect(() => {
    if (!reference) {
      navigate(-1);
      return;
    }
    const theCampain = getCampagneByReference(reference);
    if (!theCampain) {
      useToast("Campagne introuvable", {
        variant: "error",
      });
      return;
    }
    setCampagne(theCampain);
  }, [reference]);

  return (
    <div>
      <DashboardHeader subTitle="Bienvenue aux campagnes" />

      <div className="py-4">
        {campagne && (
          <SideImageCard
            loading={loading}
            imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png"
          >
            <div className="">
              <UiButton
                variant="text"
                onClick={() => navigate(-1)}
                startIcon={<ArrowLeft />}
              >
                Retour
              </UiButton>
            </div>

            <div className="p-4  w-full">
              <h1 className="text-2xl pb-4 form-title">
                {campagne?.nom ?? ""}
              </h1>

              <label className="ui-form-label flex gap-2 items-center mb-1">
                <Goal width={16} height={16} />
                Objectif
              </label>
              <div className="p-2 border border-gray-200 rounded-md mb-4">
                {campagne?.objectif ?? ""}
              </div>

              <RowInformation
                label="Réference"
                value={campagne?.reference ?? ""}
              />
              <RowInformation
                label="Type de campagne"
                value={campagne?.typeCampagne ?? ""}
              />
              <RowInformation label="Région" value={campagne?.region ?? ""} />
              <RowInformation label="Auteur" value={campagne?.auteur ?? ""} />
              <RowInformation
                label="Durée"
                value={`${campagne?.dure ?? ""} Jour(s)`}
              />
              <RowInformation
                label="Objectif de couverture"
                value={`${campagne?.objectifCouverture ?? ""} %`}
              />
              <RowInformation
                label="Estimation éleveur"
                value={campagne?.estimationEleveur ?? ""}
              />

              <RowInformation
                label="Date de début"
                value={formatAppDate(campagne?.dateDebut ?? "")}
              />
              <RowInformation
                label="Date de création"
                value={formatAppDateTime(campagne?.dateCreation ?? "")}
              />
              <RowInformation
                label="Date de modification"
                value={formatAppDateTime(campagne?.ddm ?? "")}
              />

              <RowInformation
                label="Statut"
                value={
                  <UiBadge variant={getCampagneStatusCode(campagne)}>
                    {getCampagneStatusLabel(campagne)}
                  </UiBadge>
                }
                className="my-2 py-2"
              />

              <div className="flex gap-2 flex-wrap justify-end items-center mt-8">
                <UiButton
                  size="small"
                  className="flex gap-2 items-center"
                  onClick={() =>
                    navigate(
                      `/dashboard/campagnes/edit/${campagne?.reference ?? ""}`
                    )
                  }
                >
                  <Edit /> Modifier
                </UiButton>
                {!campagne?.shelve && (
                  <UiSuspendButton
                    loading={loading}
                    label="Suspendre"
                    onClick={() => suspendCampagne(campagne?.reference ?? "")}
                  />
                )}
              </div>
            </div>
          </SideImageCard>
        )}
      </div>
    </div>
  );
}
